<template>
	<section class="tp-closed_today_wrap">
		<div v-for="item in data" :key="item.tech">
			<hr />
			<hr />
			<span>
				<b> {{ item.name }} </b>
			</span>
			<ClosedTodayRepairsTableReact :repairs="item.repairs" />
		</div>
	</section>
</template>
<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { ClosedTodayRepairsTable } from "@/modules/dashboard/components/ClosedTodayRepairsTable";

const ClosedTodayRepairsTableReact = ReactInVue(ClosedTodayRepairsTable);

export default {
	components: {
		ClosedTodayRepairsTableReact,
	},
	name: "ClosedToday",

	props: {
		data: {
			type: Array,
			required: true,
		},
	},
};
</script>
